import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Filters, ProductList, Sort, PageHero, Loading } from "../components";
import { FaSlidersH, FaTimes } from "react-icons/fa";
import ReactModal from "react-modal";
import { useProductsContext } from "../context/products_context";
import { product as urll, products_url as url } from "../utils/constants";
// import { useParams } from "react-router-dom/cjs/react-router-dom";
// import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { Link, useLocation, useParams } from "react-router-dom";
const ProductsPage = () => {
  const [show, setShow] = React.useState();
  window.scrollTo(0, 0);
  const [getModal, setModal] = useState(false);
  const [getdata2, setdata2] = useState([]);
  const [campusdata, setcampusdata] = useState([]);

  const paramm = useParams();
  const location = useLocation();

  const campus = location.state?.campus;

  console.log("campus", campus);

  var slug = paramm.id;

  useEffect(() => {
    prodatalist();
  }, []);

  const prodatalist = async () => {
    const datalist = await localStorage.getItem("productdata");
    setdata2(JSON.parse(datalist));
  };

  const { getClass, class_data, class_data_loading } = useProductsContext();

  useEffect(() => {
    if (slug) {
      GetClassData(slug);
    } else {
    }
    campuslist();
  }, []);

  const campuslist = async () => {
    const datalist = await localStorage.getItem("campusdata");
    setcampusdata(JSON.parse(datalist));
  };

  const GetClassData = async (id) => {
    var params = {
      campus_id: id,
    };

    getClass(params);
  };

  return (
    <main>
      <PageHero title={campus?.name} />

      <Wrapper>
        <div className="section-center">
          {class_data_loading === true ? (
            <>
              <Loading />
            </>
          ) : (
            <>
              <div className="row">
                {class_data && class_data.length > 0
                  ? class_data.map((c, index) => {
                      return (
                        <div className="col-md-4" key={index}>
                          <Link
                            to={`/Propage/${c.slug}?allpage`}
                            style={{ cursor: "pointer", width: "100%" }}
                            className=""
                            onClick={() => {}}
                          >
                            <div className="Propage_img_main">
                              <img
                                src={c?.image_full_path}
                                alt=""
                                style={{ marginBottom: "0px !important" }}
                              />
                              <button
                                type="button"
                                name="category"
                                value={c?.name}
                              >
                                {c?.name}
                              </button>
                            </div>
                          </Link>
                          <span style={{ color: "#5d5d9c", fontWeight: "600" }}>
                            {c?.name}
                          </span>
                        </div>
                      );
                    })
                  : null}
              </div>
            </>
          )}
        </div>
      </Wrapper>
    </main>
  );
};

const Wrapper = styled.section`
  background: var(--clr-grey-10);
  ${"" /* padding: 60px 0 0 0; */}
  padding: 60px 0;
  .title {
    margin-bottom: 30px;
    h2 {
      color: var(--clr-primary-darkred);
    }
  }
  h5 {
    font-size: 27px;
    text-transform: uppercase;
    letter-spacing: 0.2em;
    margin: 0px 0px 20px 0;
  }
  .featured {
    margin: 4rem auto;
    display: grid;
    gap: 2.5rem;
    img {
      height: 225px;
    }
  }
  .btn {
    display: block;
    width: 148px;
    margin: 0 auto;
    text-align: center;
  }
  .row {
    display: -ms-flexbox;
    display: flex;
    gap: 1rem;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    ${
      "" /* margin-right: -50px;
    margin-left: -50px; */
    }
    justify-content: center;
  }
  .col-md-4 {
    ${"" /* height: 150px; */}
    width: 150px;
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    ${"" /* max-width: 33.333333%; */}
    ${"" /* padding: 0 50px; */}
    text-align: center;
    ${"" /* margin-bottom: 30px; */}
    ${"" /* position: relative; */}
    overflow: hidden;
    .Propage_img_main {
      height: 200px;
      position: relative;
    }
    .Propage_img_main {
      img {
        ${"" /* max-width: 100%; */}
        height:100%;
        width: 100%;
        object-fit: cover;
        display: flex;
      }
      button {
        border: none;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0px;
        background: rgb(0 0 0/0.5);
        width: calc(100% - 100px);
        margin: 0 auto;
        color: #fff;
        font-size: 28px;
        letter-spacing: 0.09em;
        text-transform: uppercase;
        transform: translateY(100%);
        transition: all 0.5s ease;
        visibility: hidden;
        opacity: 0;
        cursor: pointer;
      }
      :hover {
        button {
          transform: translateY(0%);
          visibility: visible;
          opacity: 1;
          cursor: pointer;
        }
      }
    }
  }
  button {
    border: none;
  }
  @media (min-width: 576px) {
    .featured {
      grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
    }
  }
  @media (max-width: 1199px) {
    .row {
      margin-right: 0px;
      margin-left: 0px;
      .col-md-4 {
        ${"" /* padding: 0 20px; */}
      }
      .col-md-4 button {
        width: calc(100% - 40px);
      }
    }
  }
  @media (max-width: 767px) {
    .row {
      margin-right: -15px;
      margin-left: -15px;
    }
    .col-md-4 {
      padding: 0 15px;
      max-width: 50%;
      flex: 0 0 50%;
    }
    .col-md-4 a button {
      width: calc(100% - 30px) !important;
      font-size: 18px !important;

      transform: translateY(0%);
      visibility: visible;
      opacity: 1;
      cursor: pointer;
    }
  }
  ${"" /* @media (max-width: 475px) { */}
  @media (max-width: 767px) {
    .col-md-4 {
      padding: 0 15px;
      max-width: 100%;
      flex: 0 0 100%;
    }
  }
`;

export default ProductsPage;
